const SELECTOR = '[data-animate]';
const DEFAULT_OPTIONS = {
    threshold: 0.2,
    rootMargin: '0px 0px -10% 0px',
};

const PREFERS_REDUCED_MOTION = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
).matches;

function revealElement(element, observer) {
    const delay = element.dataset.animateDelay;

    if (delay) {
        element.style.setProperty('--animate-delay', `${delay}ms`);
    }

    element.classList.add('is-visible');

    if (observer) {
        observer.unobserve(element);
    }
}

export function initScrollAnimations() {
    const elements = document.querySelectorAll(SELECTOR);
    if (!elements.length) {
        return;
    }

    if (PREFERS_REDUCED_MOTION) {
        elements.forEach(element => {
            element.classList.add('is-visible');
        });
        return;
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                return;
            }

            revealElement(entry.target, observer);
        });
    }, DEFAULT_OPTIONS);

    elements.forEach(element => observer.observe(element));
}
